import { render } from "./FormDatePicker.vue?vue&type=template&id=23eff7ee&scoped=true"
import script from "./FormDatePicker.vue?vue&type=script&lang=js"
export * from "./FormDatePicker.vue?vue&type=script&lang=js"

import "./FormDatePicker.vue?vue&type=style&index=0&id=23eff7ee&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/osod-form/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23eff7ee"]])

export default __exports__